import { Users } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { SectionTag } from "../components/SectionLabel";

const MAIN_IMG =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_advocacy-reimagined/artifacts/9nf4b3x6__DSC8016.webp";

const PARTNERS = [
  {
    name: "Ana Carolina Martins",
    role: "Direito Trabalhista",
    bio: "Professora na FGV e no IERBB, integra a Comissão de Direito do Trabalho da OAB/RJ.",
  },
  {
    name: "Lilian Oliveira de Freitas",
    role: "Direito e Processo do Trabalho",
    bio: "Atua com consultivo e contencioso para pessoas físicas e jurídicas, com visão estratégica.",
  },
];

export const QuemSomos = () => (
  <section id="quem-somos" className="bg-cream py-24 lg:py-32" data-testid="quem-somos-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="grid lg:grid-cols-2 gap-16 items-start">
        <div>
          <Reveal>
            <SectionTag icon={Users} label="Quem somos" tone="brown" />
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl leading-[1.08] text-ink max-w-lg">
              Duas advogadas. Um só compromisso: o seu caso.
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-7 text-base md:text-lg text-ink-soft leading-relaxed max-w-md">
              Atuação sólida em direito do trabalho, com escuta, clareza e
              decisão bem pensada. Aqui, você fala direto com quem conduz o
              seu caso — sem intermediários, sem ruído, sem promessa vazia.
            </p>
          </Reveal>

          <div className="mt-12 grid sm:grid-cols-2 gap-8">
            {PARTNERS.map((p, i) => (
              <Reveal key={p.name} delay={0.3 + i * 0.1} className="border-t border-line pt-5">
                <h3 className="font-serif text-xl text-ink" data-testid={`partner-name-${i}`}>
                  {p.name}
                </h3>
                <span className="font-mono text-[11px] uppercase tracking-[0.15em] text-teal-dark">
                  {p.role}
                </span>
                <p className="mt-2 text-sm text-ink-soft leading-relaxed">{p.bio}</p>
              </Reveal>
            ))}
          </div>
        </div>

        <div className="relative">
          <Reveal delay={0.15} y={50} className="relative">
            <div className="absolute -bottom-6 -right-6 w-full h-full bg-teal-dark hidden sm:block" />
            <div className="relative aspect-[4/5] overflow-hidden bg-cream-dark border-4 border-brown-dark shadow-[0_20px_50px_rgba(44,36,27,0.18)]">
              <img
                src={MAIN_IMG}
                alt="Sócias Martins e Freitas Advogados Associados"
                className="w-full h-full object-cover"
                data-testid="quem-somos-main-image"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
